/** Mirrors Prisma `InvitationStatus`. */
export enum InvitationStatus {
  Pending = "pending",
  Accepted = "accepted",
  Declined = "declined",
  Expired = "expired",
  Revoked = "revoked",
}

/** Stable invitation resolution error codes. */
export enum InvitationStateErrorCode {
  InvitationNotFound = "INVITATION_NOT_FOUND",
  InvitationExpired = "INVITATION_EXPIRED",
  InvitationAccepted = "INVITATION_ACCEPTED",
  InvitationDeclined = "INVITATION_DECLINED",
  InvitationCancelled = "INVITATION_CANCELLED",
}

/** Mirrors Prisma `WorkspaceStructureType`. */
export enum WorkspaceStructureType {
  SingleBranch = "SINGLE_BRANCH",
  MultiBranch = "MULTI_BRANCH",
}

/** Explains which validated input selected the active tenant context. */
export enum TenantContextSelectionSource {
  Url = "URL",
  LastVisited = "LAST_VISITED",
  DefaultWorkspace = "DEFAULT_WORKSPACE",
  FirstAssignment = "FIRST_ASSIGNMENT",
  OrganizationFallback = "ORGANIZATION_FALLBACK",
  None = "NONE",
}

/** Backend-owned precedence for department-scoped tenant entry. */
export enum DepartmentEntryMode {
  None = "NONE",
  Focused = "FOCUSED",
  Mixed = "MIXED",
}
